import { LoaderUiModule } from './../../features/loader-ui/loader-ui.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HeaderModule } from './header/header.module';
import { FooterComponent } from './footer/footer.component';
import { NavigationModule } from './navigation/navigation.module';
import { RibbonComponent } from './ribbon/ribbon.component';
import { ShortcutComponent } from './shortcut/shortcut.component';
import { LayoutSwitcherComponent } from './layout-switcher.component';
import { MainLayoutComponent } from './app-layouts/main-layout.component';
import { EmptyLayoutComponent } from './app-layouts/empty-layout.component';
import { RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './app-layouts/auth-layout.component';
import { TooltipModule, BsDropdownModule } from 'ngx-bootstrap';
import { RouteBreadcrumbsComponent } from './ribbon/route-breadcrumbs.component';
import { UtilsModule } from '../utils/utils.module';
import { MenuPelizzaComponent } from '@app/features/menu-pelizza/menu-pelizza.component';
import { GetMenuJsonService } from '@app/core/services/get-menu-json.service';
import { ExpiredPermissionUiModule } from '@app/features/expired-permission-ui/expired-permission-ui.module';
import { AccessNoPermissionUiModule } from '@app/features/access-no-permission-ui/access-no-permission-ui.module';
import { ActionNoPermissionUiModule } from '@app/features/action-no-permission-ui/action-no-permission-ui.module';

@NgModule({
    imports: [
        CommonModule,
        HeaderModule,
        NavigationModule,
        FormsModule,
        RouterModule,
        UtilsModule,
        TooltipModule,
        BsDropdownModule,
        LoaderUiModule,
        ExpiredPermissionUiModule,
        AccessNoPermissionUiModule,
        ActionNoPermissionUiModule,
    ],
    declarations: [
        FooterComponent,
        RibbonComponent,
        ShortcutComponent,
        LayoutSwitcherComponent,
        MainLayoutComponent,
        EmptyLayoutComponent,
        AuthLayoutComponent,
        RouteBreadcrumbsComponent,
        MenuPelizzaComponent,
    ],
    exports: [
        HeaderModule,
        NavigationModule,
        FooterComponent,
        RibbonComponent,
        ShortcutComponent,
        LayoutSwitcherComponent,
        MenuPelizzaComponent,
    ],
    providers: [
        GetMenuJsonService,
    ],
})
export class SmartadminLayoutModule {

}
